import React from 'react'
import 'styles/d3/warningtext.scss'

class WarningText extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showWarning: true }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.text !== newProps.text) this.setState({ showWarning: true })
  }

  render() {
    return this.state.showWarning && this.props.text ? (
      <span className='warning-text'>
        <i onClick={() => this.setState({ showWarning: false })} className='fa fa-times-circle' />
        {this.props.text}
      </span>
    ) : null
  }
}

export default WarningText



// WEBPACK FOOTER //
// ./src/components/WarningText.js